import { HookResult, Transition, UIRouter, UrlService } from "@uirouter/angular"
import { AppsService } from "../services/applications.service";
import { AuthService } from "../services/auth.service";
import { StorageService } from "../services/storageService.service";
import { TrackingService } from "../services/tracking.service";

export function authAndAppValidationConfigFn(router: UIRouter) {
  router.transitionService.onBefore(
    {
      to: (state) => (state.name != 'login' && state.name != 'logincallback' && !state.name.includes('error'))
    },
    _onBefore,
    {
      priority: 1000
    }
  )
}

function _onBefore(transition: Transition): HookResult {
  const injector = transition.injector()
  const authService = injector.get<AuthService>(AuthService);
  return authService.isAuthenticated()
    .then(isAuthenticated => {
      if (isAuthenticated) {
        const userProfile = authService.getUserProfileSync();
        transition.promise.then(() => injector.get<TrackingService>(TrackingService).setAuthData(userProfile), () => {});
        const grantedApps = userProfile.openairApps;
        const { data, name } = transition.to();
        if (grantedApps.length > 0 && data?.app && !name?.includes('**') && !grantedApps.includes(data.app)) {
          const app = transition.injector().get<AppsService>(AppsService).getDefaultApp(grantedApps);
          return transition.router.stateService.target("deepLink", { app: app.id });
        }
        else if (grantedApps.length < 1) return handleOnBeforeError();
      }
      else return handleOnBeforeError();
    });

  function handleOnBeforeError() {
    const $url = transition.injector().get<UrlService>(UrlService);
    const storage = transition.injector().get<StorageService>(StorageService);
    storage.session.set.lastUrl($url.url());
    storage.session.set.lastUrlParts($url.parts());
    transition.abort();
    transition.router.stateService.go('login');
  }
}
